<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.operationStatusId" hidden/>

      <t-input v-model="form.name"  :add-error="error.name" label="Status Operacional" required/>

      <t-input v-model="form.typeOperation" @change="onTypeOperationChange" radio :options="StatusFinishType.list"
               help="Informe se este status é comum ou do tipo finalização, podendo ser finalizado com sucesso ou finalizado com erro."
               label="Tipo de Operação" required/>

      <t-input v-model="form.color" color-reduced label="Cor" required/>

      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import StatusFinishType from "@/model/types/resource/StatusOperationType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypeStatusProductionForm',
  data() {
    return {
      StatusFinishType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "operationStatusId",
      form: {
        operationStatusId: 0,
        name: "",
        typeOperation: 1,
        color: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeOperationChange(value) {

      if ((value === 2 && this.form.color === '') || (value === 2 && this.form.color === '#EB144C')) {
        //Seta a cor verde por padrão
        this.form.color = "#00D084"
      } else if ((value === 3 && this.form.color === '') || (value === 3 && this.form.color === '#00D084')) {
        this.form.color = "#EB144C"
      }


    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
